import React from 'react';
import { withT } from "~app/BundleProvider";
import ZoomButton from './ZoomButton';

const svgWidth = 1022;
const svgHeight = 1045;

class ZoomTool extends React.Component {
  state = {
    dragging: false,
    zoomLevel: 1,
    viewBox: {
      x: 0,
      y: 0,
      width: svgWidth,
      height: svgHeight,
    },
    dragStart: {},
  }

  componentDidUpdate() {
    if (!this.chart) {
      this.chart = document.querySelector('#chart');

      this.chart.addEventListener("mousedown", this.handleMousedown);
      window.addEventListener("mouseup", this.notDragging);
      this.chart.addEventListener("mouseleave", this.notDragging);
      this.chart.addEventListener("mousemove", this.handleMouseMove);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("mouseup", this.notDragging);
  }

  notDragging = () => this.setState({ dragging: false });

  handleMousedown = event =>

    // save the location of mousedown and current viewbox to compare to
    // difference on mousemove
    this.setState({
      dragging: true,
      dragStart: {
        clientX: event.clientX,
        clientY: event.clientY,
        viewBoxX: this.state.viewBox.x,
        viewBoxY: this.state.viewBox.y,
      },
    });

  controlXY = (x, y, nextWidth, nextHeight) => {
    // filter viewbox x / y values through here to prevent user from dragging
    // chart out of viewbox
    let newX = x,
      newY = y;
    if (x < 0) newX = 0;
    if (y < 0) newY = 0;
    if (x + nextWidth > svgWidth)
      newX = svgWidth - nextWidth;
    if (y + nextHeight > svgHeight)
      newY = svgHeight - nextHeight;

    return { x: newX, y: newY };
  };

  handleMouseMove = event => {
    if (this.state.zoomLevel > 0 && this.state.dragging) {
      const rect = this.chart.getBoundingClientRect();

      // calculate number of pixels mouse dragged across chart div in x & y direction
      const diffX = event.clientX - this.state.dragStart.clientX;
      const diffY = event.clientY - this.state.dragStart.clientY;

      // convert move diff in pixels to decimal fraction of chart div (0.0 - 1.0)
      const fracDiffX = diffX / rect.width;
      const fracDiffY = diffY / rect.height;

      // viewBox x / y changes by the same decimal fraction of the viewbox width / height
      // as the mouse dragged across the chart div
      let newX = this.state.dragStart.viewBoxX - (this.state.viewBox.width * fracDiffX);
      let newY = this.state.dragStart.viewBoxY - (this.state.viewBox.height * fracDiffY);

      // snap x / y values to acceptable values that won't allow chart to leave viewbox
      const xy = this.controlXY(newX, newY);

      // set state with updated viewbox values, then call updateChart to apply them
      this.setState(({ viewBox }) => ({ viewBox: { ...viewBox, ...xy }}), () => {
        this.updateChart();
      });
    }
  }

  zoom = direction => {
    const zoomAmt = 0.5;
    const zoomInt = direction === 'in' ? zoomAmt : zoomAmt * -1;
    let zoomLevel = this.state.zoomLevel + zoomInt;

    // snap to min / max zoomLevel values
    if (zoomLevel > 3) zoomLevel = 3;
    if (zoomLevel < 1) zoomLevel = 1;

    // if zoomLevel is 2 (i.e. 200%), viewBox will have 1 / 2 its normal width & height
    const nextWidth = Math.floor(svgWidth * (1 / zoomLevel));
    const nextHeight = Math.floor(svgHeight * (1 / zoomLevel));

    // set x and y to be in the center of zoomed area
    const { x, y, width: prevWidth, height: prevHeight } = this.state.viewBox;

    const centerZoom = (axis, prevDimension, nextDimension) =>
      axis + 0.5 * (prevDimension - nextDimension);

    const centeredX = centerZoom(x, prevWidth, nextWidth);
    const centeredY = centerZoom(y, prevHeight, nextHeight);

    const xy = this.controlXY(centeredX, centeredY, nextWidth, nextHeight);

    const updatedViewBox = {
      ...xy,
      width: nextWidth,
      height: nextHeight,
    };

    this.setState({ zoomLevel, viewBox: updatedViewBox }, () => {
      this.updateChart();
    });
  };

  updateChart = () => {
    const { x, y, width, height } = this.state.viewBox;
    const controlled = this.controlXY(x, y);
    const viewBox = `${controlled.x}, ${controlled.y}, ${width}, ${height}`;

    this.chart.setAttribute('viewBox', viewBox);

    // don't show move cursor if user is not zoomed in
    this.chart.style.cursor = this.state.zoomLevel === 1 ? "default" : "move";
  }

  render() {
    const { t } = this.props;
    return (
      <div className="ZoomTool__container">
        <h1 className="ZoomTool__pct-display">{100 * this.state.zoomLevel}%</h1>
        <ZoomButton
          handleClick={() => this.zoom("in")}
          className="ZoomTool__button"
          ariaLabel={t("zoom-in")}
        >
          +
        </ZoomButton>
        <ZoomButton
          handleClick={() => this.zoom("out")}
          className="ZoomTool__button"
          ariaLabel={t("zoom-out")}
        >
          &minus;
        </ZoomButton>
      </div>
    );
  }
}

export default withT(ZoomTool);



// WEBPACK FOOTER //
// ./src/components/ZoomTool/ZoomTool.js